import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { BoardCardRegistryService, BoardJSON } from "../lib";
import { BoardCardRendererComponent } from "./board-card-renderer.component";

@Component({
  selector: 'eas-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.css'],
  imports: [BoardCardRendererComponent, NgClass],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoardComponent {

  gridLayoutClassNames = computed(() => {
    return ['dashboard-grid-container', `col-${this.boardJSON().columns.length}`]
  });

  cardRegistry = inject(BoardCardRegistryService);

  boardJSON = input.required<BoardJSON>();
  boardId = input.required<string>();
  boardContext = input<{ user?: string }>();
  board = computed(() => this.cardRegistry.boardFromJson(this.boardJSON(), this.boardId()));
}
